module.exports = __webpack_public_path__ + "static/interior-2-ec6969fbb0040092d97033cfa04e4e46.jpg";